import React from 'react'

const NoData = () => (
  <div className='ibox-content' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    No data to display
  </div>
)
export default NoData
